import * as types from "../ActionType";
import axios from "axios";
import { notifyError , notifysuccess } from "../../components/general/Notification";
import { hasExpiritionWithLoad } from "../../components/general/general-component/abstruct-component/useExpirition";
const END_POINT = process.env.REACT_APP_BASE_URL;

const get = (arr,type) => {
    return ({
        type: type,
        payload: arr
    })
}
const delelte = (type) => {
    return ({
        type: type
    })
}

const empty = (empty, typee) => {
    return ({
        type: typee,
        payload: empty
    })
}


export const loadEvaluationDetails = (creativeWorkId) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${END_POINT}/api/creative-work/${creativeWorkId}/evaluations`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res.data.data,types.GET_EVALUATION_DETAILS_TYPE));
            }
        }).catch((err) => {
            notifyError(err.response.data.message)
        })
    }
}

export const emptyEvaluationDetails = () => {
    return function (dispatch) {
        let emptyy = []
        dispatch(empty(emptyy, types.EMPTY_EVALUATION_DETAILS_TYPE))
    }
}

export const loadEvaluationDetailsByReader = (reader_id,creativeWorkId) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${END_POINT}/api/evaluations/user/${reader_id}?creative_work_id=${creativeWorkId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res.data.data,types.GET_EVALUATION_DETAILS_BY_READER));
            }
        }).catch((err) => {
            notifyError(err.response.data.message)
        })
    }
}

export const emptyEvaluationDetailsByReader  = () => {
    return function (dispatch) {
        let emptyy = []
        dispatch(empty(emptyy, types.EMPTY_EVALUATION_DETAILS_BY_READER))
    }
}

export const deleteEvaluationByReader= (reader_id,creativeWorkId,setloadDel) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        setloadDel(true)
        axios.delete(`${END_POINT}/api/creative-work/${creativeWorkId}/evaluations/delete?user_id=${reader_id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.status == "Success") {
                dispatch(delelte(types.DELETE_EVALUATION_DETAILS_BY_READER));
                notifysuccess(res.data.message)
                dispatch(loadEvaluationDetails(creativeWorkId));
                setloadDel(false)
            }
        }).catch((err) => {
            console.log(err)
            setloadDel(false)
            notifyError(err.response.data.message)
        })
    }
}
